import { Button, Col, Collapse, Input, Row } from "antd";
import facebook from "assets/img/facebook.png";
import instagram from "assets/img/instagram.png";
import lazada from "assets/img/lazada.png";
import sendo from "assets/img/sendo.png";
import shopee from "assets/img/shopee.png";
import tiki from "assets/img/tiki.png";
import youtube from "assets/img/youtube.png";
import zalo from "assets/img/zalo.png";

import { ReactComponent as IconEmail } from "assets/icons/IconEmail.svg";
import { ReactComponent as IconMap } from "assets/icons/IconMap.svg";
import { ReactComponent as IconPhone } from "assets/icons/IconPhone.svg";
import Market from "assets/img/market.png";

import Notificationed from "assets/img/notificationed.png";
import Protected from "assets/img/protected.png";

import "./styles.scss";
import { CaretDownOutlined } from "@ant-design/icons";

const { Panel } = Collapse;

export default function Footer() {
  return (
    <div className="footer">
      <Row gutter={32}>
        <Col xs={24} sm={24} lg={8} xl={8} xxl={8} className="footer-col">
          <p className="footer-core-value">
            “Đặt sự hài lòng của khách hàng là ưu tiên số 1 trong mọi suy nghĩ
            hành động của mình” là sứ mệnh, là triết lý, chiến lược.. luôn cùng
            YODY tiến bước
          </p>

          <div className="footer-register">
            <p className="footer-register-title">ĐĂNG KÝ NHẬN THÔNG TIN</p>
            <div className="footer-register-box">
              <Input
                placeholder="Nhập email đăng ký của bạn"
                className="footer-register-box-input"
              />
              <Button className="footer-register-box-btn">Đăng ký</Button>
            </div>
          </div>

          <div className="footer-socials">
            <a href="https://www.facebook.com/yody.vn">
              <img src={facebook} alt="facebook" />
            </a>
            <a href="https://www.youtube.com/channel/UCfRq5SO7a2fWyTzkGB-5t8g?view_as=subscriber">
              <img src={youtube} alt="youtube" />
            </a>
            <a href="https://www.instagram.com/yody.vn/">
              <img src={instagram} alt="instagram" />
            </a>
            <a href="https://zalo.me/330373955557900892">
              <img src={zalo} alt="zalo" />
            </a>
            <a href="https://shopee.vn/yody.official">
              <img src={shopee} alt="shopee" />
            </a>
            <a href="https://www.lazada.vn/shop/yody/">
              <img src={lazada} alt="lazada" />
            </a>
            <a href="https://www.sendo.vn/thuong-hieu/yody/">
              <img src={sendo} alt="sendo" />
            </a>
            <a href="https://tiki.vn/cua-hang/yody-official-store">
              <img src={tiki} alt="tiki" />
            </a>
          </div>
        </Col>

        <Col xs={24} sm={24} lg={4} xl={4} xxl={4} className="footer-col">
          <Collapse
            className="footer-about-yody-list"
            defaultActiveKey={window.innerWidth > 767 ? ["1"] : ""}
            expandIcon={({ isActive }) => (
              <CaretDownOutlined rotate={isActive ? 180 : 0} />
            )}
          >
            <Panel key="1" header="VỀ YODY">
              <ul className="footer-about-yody-list">
                <a href="https://yody.vn/gioi-thieu">
                  <li className="footer-about-yody-item">Giới thiệu</li>
                </a>
                <a href="https://yody.vn/lien-he">
                  <li className="footer-about-yody-item">Liên hệ</li>
                </a>
                <a href="https://tuyendung.yody.vn/">
                  <li className="footer-about-yody-item">Tuyển dụng</li>
                </a>
                <a href="https://yody.vn/yody-love">
                  <li className="footer-about-yody-item">Tin tức</li>
                </a>
                <a href="https://yody.vn/he-thong-cua-hang">
                  <li className="footer-about-yody-item">Hệ thống cửa hàng</li>
                </a>
              </ul>
            </Panel>
          </Collapse>
        </Col>

        <Col xs={24} sm={24} lg={5} xl={5} xxl={5} className="footer-col">
          <Collapse
            className="footer-about-yody-list"
            defaultActiveKey={window.innerWidth > 767 ? ["1"] : ""}
            expandIcon={({ isActive }) => (
              <CaretDownOutlined rotate={isActive ? 180 : 0} />
            )}
          >
            <Panel key="1" header="HỖ TRỢ KHÁCH HÀNG">
              <ul className="footer-about-yody-list">
                <a href="https://yody.vn/bang-size-chuan">
                  <li className="footer-about-yody-item">
                    Hướng dẫn chọn size
                  </li>
                </a>
                <a href="https://yody.vn/chinh-sach-khach-hang-than-thiet">
                  <li className="footer-about-yody-item">
                    Chính sách khách hàng thân thiết
                  </li>
                </a>
                <a href="https://yody.vn/chinh-sach-doi-tra">
                  <li className="footer-about-yody-item">Chính sách đổi/trả</li>
                </a>
                <a href="https://yody.vn/chinh-sach-bao-mat">
                  <li className="footer-about-yody-item">Chính sách bảo mật</li>
                </a>
                <a href="https://yody.vn/chinh-sach-giao-nhan-hang-online">
                  <li className="footer-about-yody-item">
                    Thanh toán, giao nhận
                  </li>
                </a>
                <a href="https://yody.vn/chinh-sach-dong-phuc-yody-2022">
                  <li className="footer-about-yody-item">
                    Chính sách Đồng phục
                  </li>
                </a>
                <a href="https://yody.vn/chinh-sach-bao-mat-thong-tin-khach-hang-1">
                  <li className="footer-about-yody-item">
                    Chính sách bảo mật thông tin khách hàng
                  </li>
                </a>
              </ul>
            </Panel>
          </Collapse>
        </Col>

        <Col xs={24} sm={24} lg={7} xl={7} xxl={7} className="footer-col">
          <Collapse
            className="footer-about-yody-list"
            defaultActiveKey={window.innerWidth > 767 ? ["1"] : ""}
            expandIcon={({ isActive }) => (
              <CaretDownOutlined rotate={isActive ? 180 : 0} />
            )}
          >
            <Panel key="1" header="CÔNG TY CP THỜI TRANG YODY">
              <ul className="footer-about-yody-list">
                <li className="footer-about-yody-item">
                  <span className="icon-map">
                    <IconMap />
                  </span>
                  <div className="footer-about-yody-item-desc">
                    <p>Công ty cổ phần Thời trang YODY</p>
                    <p style={{ padding: "4px 0" }}>Mã số thuế: 0801206940</p>
                    <p>
                      Địa chỉ: Đường An Định - Phường Việt Hòa - Thành phố Hải
                      Dương - Hải Dương
                    </p>
                  </div>
                </li>
                <li className="footer-about-yody-item">
                  <img src={Market} alt="Market" />
                  <p
                    className="footer-about-yody-item-desc"
                    style={{ alignSelf: "center" }}
                  >
                    Tìm cửa hàng gần bạn nhất
                  </p>
                </li>
                <li className="footer-about-yody-item">
                  <span>
                    <IconPhone />
                  </span>
                  <p className="footer-about-yody-item-desc">
                    Liên hệ đặt hàng: 024 999 86 999
                    <p style={{ padding: "4px 0" }}>
                      Thắc mắc đơn hàng: 024 999 86 999
                    </p>
                    Góp ý khiếu nại: 1800 2086
                  </p>
                </li>
                <li className="footer-about-yody-item">
                  <span>
                    <IconEmail style={{ position: "relative", top: 3 }} />
                  </span>
                  <p
                    className="footer-about-yody-item-desc"
                    style={{ alignSelf: "center" }}
                  >
                    Email: chamsockhachhang@yody.vn
                  </p>
                </li>
              </ul>
            </Panel>
          </Collapse>

          <div className="footer-confirm">
            <img
              src={Notificationed}
              alt="Đăng ký bộ công thương"
              className="footer-confirm-notificationed"
            />
            <img src={Protected} alt="Protected" />
          </div>
        </Col>
      </Row>

      <div className="footer-copyright">
        © YODY - Bản quyền thuộc về Công ty cổ phần thời trang YODY
      </div>
    </div>
  );
}
